import { render, staticRenderFns } from "./tab-two.vue?vue&type=template&id=096546b3&"
import script from "./tab-two.vue?vue&type=script&lang=ts&"
export * from "./tab-two.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports